var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgToolsWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "513px",
    height: "513px",
    viewBox: "0 0 513 513",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.15 395.7L384.05 278.6C360.95 255.5 326.45 251 298.65 264.7L192.05 158.1L192.05 96L64.05 0L0.0499878 64L96.05 192L158.15 192L264.75 298.6C251.15 326.4 255.55 360.9 278.65 384L395.75 501.1C410.35 515.7 433.95 515.7 448.45 501.1L501.15 448.4C515.65 433.8 515.65 410.2 501.15 395.7ZM406.65 256C386.65 236 360.05 225 331.75 225C323.55 225 315.15 226 307.05 227.9L224.95 145.8C224.25 108.3 237.65 70.7 266.15 42.2C303.15 5.20002 355.35 -7.39998 402.75 4.30002C411.85 6.60002 415.05 17.9 408.45 24.5L334.05 98.9L345.35 166.8L413.25 178.1L487.65 103.7C494.25 97.1 505.55 100.2 507.75 109.2C519.55 156.6 506.95 208.8 469.85 245.9C456.85 258.9 441.85 268.5 426.05 275.4L406.65 256ZM227.85 307L171.15 250.3L18.75 402.8C-6.25 427.8 -6.25 468.3 18.75 493.3C43.75 518.3 84.25 518.3 109.25 493.3L232.85 369.7C225.25 349.8 222.95 328.1 227.85 307ZM40.05 448C40.05 461.2 50.85 472 64.05 472C77.35 472 88.05 461.2 88.05 448C88.05 434.7 77.35 424 64.05 424C50.75 424 40.05 434.7 40.05 448Z",
    id: "tools-white",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToolsWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tools-white.3b8e7124bb32841283fcb347a65b4a80.svg";